import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className="bg-black text-white/50 text-xs py-8 border-t border-white/5 mt-auto">
            <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center gap-4">
                <div className="text-center md:text-left">
                    <p>&copy; {new Date().getFullYear()} VipEncuentros.com. Todos los derechos reservados.</p>
                </div>
                <div className="flex gap-6">
                    <Link to="/terminos-condiciones" className="hover:text-white transition-colors">
                        Términos y Condiciones
                    </Link>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
